import React from 'react';
import { useSparkStepByID } from 'hooks/SparkBuilder/sparkStep';
import { useSparkBuilderStore } from 'stores';
import { SparkDynamicOutput } from 'sharedComponents/UI';
import { useTransformPromptReferences } from './utils';
import { Box } from '@mui/material';

type SparkTestsInputProps = {
  isParentLoading?: boolean;
};

function SparkTestsInput({ isParentLoading = false }: SparkTestsInputProps) {
  const transformReference = useTransformPromptReferences();
  const selectedStep = useSparkBuilderStore(
    React.useCallback((store) => store.builderSideBar.selectedStep, [])
  );

  const { data: sparkStep } = useSparkStepByID(selectedStep?.id);

  const input = React.useMemo(
    () => JSON.stringify(sparkStep?.data.meta?.inputResolved),
    [sparkStep?.data.meta?.inputResolved]
  );

  return (
    <Box paddingX={2}>
      <SparkDynamicOutput
        output={input || ''}
        transformReference={transformReference}
      />
    </Box>
  );
}

export default SparkTestsInput;
